module.exports = __webpack_public_path__ + "img/NewMiniBusIcon.4a11797a.svg";